// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xIcd","fullView":"styles_fullView__2LC6C"};